<template>
    <div class="wrapper" v-if="showComponent">
        <div class="label">{{header}}</div>
        <div class="countdown">
            <div class="countdown-component">
                <div class="value">{{days}}</div>
                <div class="label">{{daysLbl}}</div>
            </div>
            <div class="countdown-component">
                <div class="value">{{hours}}</div>
                <div class="label">{{hoursLbl}}</div>
            </div>
            <div class="countdown-component">
                <div class="value">{{minutes}}</div>
                <div class="label">{{minutesLbl}}</div>
            </div>
            <div class="countdown-component">
                <div class="value">{{seconds}}</div>
                <div class="label">{{secondsLbl}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {events, StringService} from '@nuskin/ns-util'

const DAY = 24 * 60 * 60 * 1000
const HOUR = 60 * 60 * 1000
const MINUTE = 60 * 1000

export default {
  name: 'EventCountdown',

  props: {
    eventName: String
  },

  data() {
    return {
      header: '',
      daysLbl: '',
      days: 0,
      hoursLbl: '',
      hours: 0,
      minutesLbl: '',
      minutes: 0,
      secondsLbl: '',
      seconds: 0,
      hasContent: false,
      showCountdown: false,
      waitTime: 0,
      intervalId: null
    }
  },

  computed: {
    showComponent() {
      return this.hasContent && this.showCountdown
    }
  },

  watch: {
    eventName(newValue, oldValue) {
      if (!oldValue && newValue) {
        events.getValue(events.salesevent.PRE_EVENT, this.preEvent, true)
        events.getValue(events.salesevent.IN_EVENT, this.inEvent, true)
        events.getValue(events.salesevent.POST_EVENT, this.postEvent, true)
        events.publish(events.salesevent.INIT_EVENT_TICKET, [this.eventName, true])
      }
    }
  },

  mounted() {
    this.setContent()
  },

  methods: {
    preEvent(eventName, paused, timeInfo) {
      if (eventName === this.eventName && timeInfo && timeInfo.fromServer) {
        if (timeInfo.waitTime >= 1000) {
          this.showCountdown = true
          this.waitTime = timeInfo.waitTime
          this.setTimeValues()

          clearInterval(this.intervalId)
          this.intervalId = setInterval(() => {
            this.waitTime -= 1000
            if (this.waitTime < 1000) {
              this.waitTime = 0
              clearInterval(this.intervalId)
            }
            this.setTimeValues()
          }, 1000)
        }
      }
    },

    inEvent(eventName) {
      if (eventName === this.eventName) {
        if (this.intervalId) {
          this.waitTime = 0
          this.setTimeValues()
          clearInterval(this.intervalId)
        } else {
          this.showCountdown = false
        }
      }
    },

    postEvent(eventName) {
      if (eventName === this.eventName) {
        this.showCountdown = false
      }
    },

    setTimeValues() {
      this.days = Math.floor(this.waitTime / DAY)
      this.hours = Math.floor((this.waitTime - (this.days * DAY)) / HOUR)
      this.minutes = Math.floor((this.waitTime - (this.days * DAY) - (this.hours * HOUR)) / MINUTE)
      this.seconds = Math.floor((this.waitTime - (this.days * DAY) - (this.hours * HOUR) - (this.minutes * MINUTE)) / 1000)
    },

    setContent() {
      StringService.getApplicationStrings('preview').then((content) => {
        this.header = content.countdownHeader
        this.daysLbl = content.days
        this.hoursLbl = content.hours
        this.minutesLbl = content.minutes
        this.secondsLbl = content.seconds
        this.hasContent = this.header && this.daysLbl && this.hoursLbl && this.minutesLbl && this.secondsLbl
      })
    }
  }
}

</script>

<style scoped lang="scss">
    .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: white;
        border: 1px solid white;
        border-radius: 5px;
        max-width: 325px;
        margin: 15px auto 0;
        padding: 5px;

        .label {
            font-size: 14px;
            text-transform: uppercase;
        }

        .countdown {
            display: flex;
            justify-content: center;

            .countdown-component {
                display: flex;
                flex-direction: column;
                width: 75px;

                .value {
                    font-weight: bold;
                    font-size: 22px;
                }

                .label {
                    font-size: 12px;
                }
            }
        }
    }

</style>
